<script setup>
import { ref, computed, defineEmits, onMounted } from 'vue';
import ProBadge from './ProBadge.vue';

const props = defineProps({
    modelValue : {
        type: String,
        default: ''
    },
    custom : {
        type: String,
        default: ''
    },
    default : {
        type: String,
        default: () => {
            // Global property Image.
            return formychat_admin_vars.public + '/images/whatsapp.svg'
        }
    },
    locked: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue', 'change', 'update:custom']);

const custom = ref( props.custom );
const selected = ref( props.modelValue || props.default );

const select = (value) => {
    selected.value = value;
    emit('update:modelValue', value);
    emit('change', value);
}

const openMediaLibrary = () => {

    if (isLocked.value) return;

    wp.media.editor.send.attachment = function(props, attachment) {
        custom.value = attachment.url;
        emit('update:custom', attachment.url);
        select( custom.value );
    };
    wp.media.editor.open();
}

const isDefaultSelected = computed(() => selected.value == props.default );

onMounted(() => {
    if( ! props.modelValue ) {
        select( props.default );
    }
});

const isLocked = computed( () => {
    return props.locked && !formychat_admin_vars.is_premium
});

</script>
<template>
    <div class="flex items-center child:shadow-sm child-hover:shadow  gap-4 w-fit child:w-[70px] child:h-[70px] child:overflow-hidden child:rounded child:flex child:items-center child:bg-gray-100 child:justify-center child:cursor-pointer child:transition-all child-hover:bg-white">
        <div class="ring-1 ring-gray-200 " @click="select(props.default)" :class="{'ring-indigo-500 ring-[2px]' : isDefaultSelected}">
            <img class="h-auto w-[80%]" :src="props.default" alt="">
        </div>
        <div @click.prevent="custom ? select(custom) : openMediaLibrary()" :class="{'ring-indigo-500 ring-[2px]' : !isDefaultSelected}" class="group relative ring-1 ring-gray-200 text-gray-500 hover:text-gray-700">
            <img v-if="custom" class="h-auto w-full" :src="custom" alt="">
            <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-1/3 fill-current" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
<path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
            </svg>
            <div v-if="custom" class="translate-y-20 transition-all group-hover:translate-y-0 absolute bottom-0 w-full bg-white flex items-center justify-center py-1">
                <svg @click.stop="select(props.default), custom = '', $emit('update:custom', '')" xmlns="http://www.w3.org/2000/svg" class="text-red-300 hover:text-red-600 transition fill-current w-4" viewBox="0 0 16 16">
                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"/>
                </svg>
            </div>

            <div v-if="isLocked" class="rounded group-hover:flex hidden justify-center items-center absolute left-0 top-0 w-full h-full formychat-locked">
                <div class="bg-white absolute left-0 top-0 w-full h-full rounded z-0 opacity-50"></div>
                <ProBadge text=""/>
            </div>
        </div>
    </div>
</template>